import { useState, useEffect, useRef } from "react";
import "./hero-splash.scss";


const HOLD_DURATION = 1000;
const FADE_DURATION = 400;

const SearchTransition = ({ show, cityName, onComplete }) => {
  const [phase, setPhase] = useState("hold");
  const timerRef = useRef(null);

  useEffect(() => {
    if (show) {
      setPhase("hold");

      timerRef.current = setTimeout(() => {
        setPhase("exit");
        setTimeout(() => {
          onComplete?.();
        }, FADE_DURATION);
      }, HOLD_DURATION);

      return () => {
        if (timerRef.current) clearTimeout(timerRef.current);
      };
    }
  }, [show, onComplete]);

  if (!show) return null;

  return (
    <div
      className="search-transition"
      style={{
        opacity: phase === "exit" ? 0 : 1,
      }}
    >
      <div className="search-transition__content">
        <div className="search-transition__bar">
          <div className="search-transition__bar-fill" />
        </div>
        <h2>Searching for buyers in {cityName}...</h2>
      </div>
    </div>
  );
};

export default SearchTransition;
